export default {
  address: '高雄市鳳山區鳳捷路 & 環河街',
  googleSrc:
    'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1841.3753429954274!2d120.3861762!3d22.6257834!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e1b09771a9585%3A0xb7e86afd528069e5!2zODMw6auY6ZuE5biC6bOz5bGx5Y2A6bOz5o236LevICYg55Kw5rKz6KGX!5e0!3m2!1szh-TW!2stw!4v1577892786904!5m2!1szh-TW!2stw',
  googleLink: 'https://goo.gl/maps/p7g29VTdQDmUAwhT6',
  phone: '07-7027555',
  fbLink: 'https://www.facebook.com/%E4%BA%AC%E5%9F%8E%E9%B3%B3%E7%BF%94-111948606978067/',
  fbMessage: 'https://m.me/111948606978067',
  caseName: '京城鳳翔',
  indigatorLength: 8,

  houseInfos: [
    // ['建造執照', '108股建字第00042號'],
    // ['建設公司', '中德建設股份有限公司'],
    // ['建築師', '呂建勳建築師'],
    // ['公設比', '32.5%'],
    // ['容積率', '299.99%'],
    // ['建蔽率', '36.99%'],
    // ['基地坪數', '832.37坪'],
    // ['基地位置', '新北市五股區新五路三段2號旁'],
    // ['企劃銷售', '海沃創意行銷'],
    // ['銷售坪數', '18-33坪'],
    // ['樓層規劃', 'A棟地上14樓、B棟地上14樓，地下6層'],
    // ['可售戶數', '182戶'],
    // ['汽車車位', '205車位'],
    // ['本案特色', '大廳挑高約4米2、百坪公設大會館<br />約二百坪景觀中庭花園、空中花園'],
  ],

  gtmCode: ['WNB9V3S'], // 可放置多個
  recaptcha_site_key_v2: '6Lep-78UAAAAAMaZLtddpvpixEb8cqu7v7758gLz',
  recaptcha_site_key: '6Lck-L8UAAAAABxfvNA1NJuBrdl3iLFc3GkudC8s', // recaptcha v3
  recaptcha_user_token: '6Lck-L8UAAAAAIcvenwGDl8_Q1tKbrEYsKuriePa',
  order: {
    title: '預約賞屋',
    subTitle: '請留下您的大名、電話、進行預賞屋!'
  }
}
